export enum AuthErrorCode {
  AuthNotValid = 'AuthNotValid',
  InvalidCredentials = 'InvalidCredentials',
  InvalidInput = 'InvalidInput',
  AuthFailedError = 'AuthFailedError',
  UpdatePasswordError = 'UpdatePasswordError',
  ResetPasswordError = 'ResetPasswordError',
  SubscriptionExpired = 'SubscriptionExpired',
  SubscriptionDisabled = 'SubscriptionDisabled',
  TokenCreationError = 'TokenCreationError',
  RefreshTokenError = 'RefreshTokenError',
  LogoutError = 'LogoutError',
  LoginAttemptError = 'LoginAttemptError',
  GenericError = 'GenericError',
  UserDoesNotExistError = 'UserDoesNotExistError',
  TokenDoesNotExistError = 'TokenDoesNotExistError',
  TokenExpiredError = 'TokenExpiredError',
  CsrfValidationError = 'CsrfValidationError',
  CsrfGenerationError = 'CsrfGenerationError',
  MfaRequired = 'MfaRequired',
  MfaInvalidOtp = 'MfaInvalidOtp',
  MfaTempTokenExpired = 'MfaTempTokenExpired',
  MfaTempTokenInvalid = 'MfaTempTokenInvalid',
  MfaTooManyAttempts = 'MfaTooManyAttempts',
  MfaSetupError = 'MfaSetupError',
}
